<template>
  <div>
        <div v-if="loading" class="brand-container">
            <p class="mt-3">Loading...</p>
        </div>

        <div v-else-if="error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="getProduct"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="hero">
                <div class="brand-container">
                    <div class="hero__content">
                        <div class="hero__logo">
                            <router-link to="/"><img :src="product.brand.logo" alt="" /></router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cabinet cabinet-supplier brand-page">
                <div class="brand-container">
                    <section class="cabinet__breadcrumbs">
                        <router-link to="/" class="cabinet__breadcrumbs-link d-flex">{{ product.brand.BrandName }}</router-link>
                        <span class="cabinet__breadcrumbs-arrow d-flex">&rsaquo;</span>
                        <router-link to="/products" class="cabinet__breadcrumbs-link d-flex">Каталог</router-link>
                        <span class="cabinet__breadcrumbs-arrow d-flex">&rsaquo;</span>
                        <router-link :to="{ name: 'SubdomainBrandProducts', params: { filterBy: { 'types': product.type.TypeID } } }" class="cabinet__breadcrumbs-link">{{ product.type.Name }}</router-link>
                    </section>

                    <div class="cabinet__product-page">
                        <div
                            class="cabinet-product-card cabinet-product-card--supplier d-flex flex-column flex-lg-row"
                        >
                            <section
                                class="cabinet-product-detail d-flex flex-column flex-md-row justify-content-md-between w-100"
                            >
                                <div class="cabinet-product-left">
                                    <image-swiper :images="product.images" />

                                    <div v-if="isMobile" class="d-md-none pt-4">
                                        <h2 class="h2 cabinet-title pt-1">
                                            {{ product.Name || product.type.Name }}
                                        </h2>
                                        <div class="subtitle1 pt-2" v-if="product.price_expired == false">
                                            <template v-if="product.price_expired == false">
                                                <div v-if="product.Price > 0">
                                                    {{ getFormattedNum(product.Price || 0) }}
                                                    ₽{{ priceUnit }}
                                                </div>
                                                <div v-else>
                                                    Цена не указана
                                                </div>
                                            </template>
                                        </div>
                                        <div class="pt-3 d-flex">
                                            <adding-and-deleting-to-public-cart
                                                :item="product"
                                                :blue="true"
                                            />
                                        </div>
                                    </div>

                                    <div
                                        v-if="product.sets.length"
                                        class="pt-4 mt-4 garniture garniture--supplier"
                                    >
                                        <div class="d-flex align-items-center">
                                            <div class="subtitle1">Гарнитур</div>
                                            <p
                                                class="caption mb-0 pl-2 pt-1 text-gray garniture__number"
                                            >
                                                {{ product.sets[0].set_article }}
                                            </p>
                                        </div>
                                        <div
                                            v-if="itemsInSet.length"
                                            class="garniture__list d-flex flex-wrap align-items-center"
                                        >
                                            <div
                                                v-for="itemInSet in itemsInSet"
                                                :key="itemInSet.item_id"
                                                class="garniture__item"
                                            >
                                                <router-link
                                                    :to="{
                                                        name: 'ProductID',
                                                        params: { id: itemInSet.item_id }
                                                    }"
                                                >
                                                    <img
                                                        :src="
                                                            itemInSet.item.images.length
                                                                ? itemInSet.item.images[0]
                                                                    .url
                                                                : ''
                                                        "
                                                        alt=""
                                                    />
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="cabinet-product-right">
                                    <div v-if="!isMobile" class="d-none d-md-block">
                                        <h2 class="h2 cabinet-title pt-1">
                                            {{ product.Name || product.type.Name }}
                                        </h2>
                                        <div class="subtitle1 pt-2" v-if="product.price_expired == false">
                                            <template v-if="product.price_expired == false">
                                                <div v-if="product.Price > 0">
                                                    {{ getFormattedNum(product.Price || 0) }}
                                                    ₽{{ priceUnit }}
                                                </div>
                                                <div v-else>
                                                    Цена не указана
                                                </div>
                                            </template>
                                        </div>
                                        <div class="pt-3 d-flex">
                                            <adding-and-deleting-to-public-cart
                                                :item="product"
                                                :blue="true"
                                            />
                                        </div>
                                    </div>

                                    <div class="mt-4">
                                        <cabinet-tabs :tabs="tabs">
                                            <product-specifications
                                                slot="0"
                                                :product="product"
                                                :is-subdomain-brand="true"
                                            />
                                            <product-inserts slot="1" :product="product" />
                                            <product-description
                                                slot="2"
                                                :description="product.Description"
                                            />
                                        </cabinet-tabs>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import CabinetTabs from '@/components/Cabinet/Tabs'
import getNameById from '@/mixins/getNameById'
import onResize from '@/mixins/on-resize.js'
import getFormattedNum from '@/utils/getFormattedNum'
import ProductSpecifications from '@/components/Cabinet/Product/Specifications'
import ProductDescription from '@/components/Cabinet/Product/Description'
import ProductInserts from '@/components/Cabinet/Product/Inserts'
import ImageSwiper from '@/components/Cabinet/Retailer/Product/Detail/DetailSwiper.vue'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'

export default {
    name: 'SubdomainBrandProduct',

    components: {
        ProductSpecifications: ProductSpecifications,
        ProductInserts: ProductInserts,
        ProductDescription: ProductDescription,
        CabinetTabs,
        ImageSwiper,
        AddingAndDeletingToPublicCart
    },

    mixins: [getNameById, onResize],

    data() {
        return {
            error: false,
            loading: true,
            product: null,
        }
    },

    computed: {
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('publicSets', ['itemsInSet']),
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        },
        tabs() {
            let tabs = ['Характеристики', 'Вставки']
            if (this.product && this.product.Description) {
                tabs.push('Описание')
            }
            return tabs
        }
    },

    async created() {
        await this.getProduct()

        document.title = this.product.Name
        document.getElementsByTagName('meta')["description"].content = this.product.Description

        this.getInsertMaterials()
        this.getInsertFacets()
        this.getInsertColors()
        this.getCollections()
        this.getTechnologies()
    },

    methods: {
        ...mapActions('publicSets', ['getItemsInSet']),
        ...mapActions('insert', [
            'getInsertMaterials',
            'getInsertFacets',
            'getInsertColors'
        ]),
        ...mapActions('collections', ['getCollections']),
        ...mapActions('technologies', ['getTechnologies']),
        async getProduct() {
            try {
                this.loading = true
                this.error = false
                this.$Progress.start()

                const res = await this.$axios.get(`/public/items/${this.$route.params.id}`)

                this.product = res.data

                if (this.product.sets.length) {
                    await this.getItemsInSet({
                        setID: this.product.sets[0].set_id
                    })
                }
            } catch (e) {
                this.error = true
            } finally {
                this.loading = false
                this.$Progress.finish()
            }
        },
        getFormattedNum
    }
}
</script>